module.exports = __webpack_public_path__ + "static/media/timelapse_8.d9561f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_8.jpg
// module id = 968
// module chunks = 0